import Statistic from "./Statistic";
import request from "../../../request";
import { formatMoney } from "../../../../../shared/utils";

export default function LoanPayments() {

   return <Statistic
      title="Loan Payments"
      fetchData={async (from, to) => {

         const res = await request.get('/api/general/reports/loan-payments', { params: { from, to } });
         const { total, count } = res.data

         const tabs = [
            {
               label: "Total",
               cards: [
                  {
                     title: "Overall",
                     number: formatMoney(total.overall)
                  },
                  {
                     title: "Collected",
                     number: formatMoney(total.collected)
                  },
                  {
                     title: "Expected",
                     number: formatMoney(total.expected)
                  }
               ]
            },
            {
               label: "Count",
               cards: [
                  {
                     title: "Overall",
                     number: count.overall
                  },
                  {
                     title: "Overdue",
                     number: count.overdue
                  },
                  {
                     title: "On Time",
                     number: count.on_time
                  }
               ]
            }
         ]

         return tabs;
      }}
   />
}